export enum PROVISIONING_DASHBOARD {
    /**
     * @value Confirm deactivation
     * @description it is a confirm button
     */
    CONFIRM_DEACTIVATION = 'PROVISIONING_DASHBOARD.CONFIRM_DEACTIVATION',
    /**
     * @value Provisioning dashboard
     */
    DASHBOARD = 'PROVISIONING_DASHBOARD.NAME',
    /**
     * @value Show conflict
     */
    DISPLAY_CONFLICTS = 'PROVISIONING_DASHBOARD.DISPLAY_CONFLICT',
    /**
     * @value duplicated profiles
     */
    DUPLICATED_PROFILES = 'PROVISIONING_DASHBOARD.DUPLICATED_PROFILES',
    /**
     * @value Multiple profiles have the same federation value.
     */
    DUPLICATED_PROFILES_DESC = 'PROVISIONING_DASHBOARD.DUPLICATED_PROFILES_DESC',
    /**
     * @value This section gives you access to synchronization tasks
     */
    EMPTY_STATE_DESCRIPTION = 'PROVISIONING_DASHBOARD.EMPTY_STATE_DESCRIPTION',
    /**
     * @value No synchronization tasks yet
     */
    EMPTY_STATE_TITLE = 'PROVISIONING_DASHBOARD.EMPTY_STATE_TITLE',
    /**
     * @value incompatible profiles
     */
    INCOMPATIBLE_PROFILES = 'PROVISIONING_DASHBOARD.INCOMPATIBLE_PROFILES',
    /**
     * @value Federation value already assigned to another profile.
     */
    INCOMPATIBLE_PROFILES_DESC = 'PROVISIONING_DASHBOARD.INCOMPATIBLE_PROFILES_DESC',
    /**
     * @value inconsistent profiles
     */
    INCONSISTENT_PROFILES = 'PROVISIONING_DASHBOARD.INCONSISTENT_PROFILES',
    /**
     * @value Profiles synchronized with multiple identity providers do not have an identical federation value in all providers anymore.
     */
    INCONSISTENT_PROFILES_DESC = 'PROVISIONING_DASHBOARD.INCONSISTENT_PROFILES_DESC',
    /**
     * @value A mass deactivation of %PERCENT%% of users has been detected and prevented.
     */
    MASS_DEACTIVATION_ALERT_TITLE = 'PROVISIONING_DASHBOARD.MASS_DEACTIVATION_ALERT_TITLE',
    /**
     * @value If you confirm the deactivation, impacted profiles will be deactivated (the process might take up to 5 minutes).<br><br>Deactivated profiles cannot log in to the platform and cannot be searched. Any content made by deactivated users, however, will remain on the platform.<br><br>Profiles that have been deactivated are not deleted. Profiles can be reactivated at any time.
     */
    MASS_DEACTIVATION_DIALOG = 'PROVISIONING_DASHBOARD.MASS_DEACTIVATION_DIALOG_BODY',
    /**
     * @value Deactivate %NUMBER% profiles?
     */
    MASS_DEACTIVATION_DIALOG_TITLE = 'PROVISIONING_DASHBOARD.MASS_DEACTIVATION_DIALOG_TITLE',
    /**
     * @value The mass deactivation is the result of recent modifications to the configuration of your providers. If the mass deactivation is intentional, confirm the deactivation of users. Impacted profiles are not deactivated until confirmation. If the mass deactivation is not intentional, review the configuration of your providers.
     */
    MASS_DEACTIVATION_MESSAGE_ALERT = 'PROVISIONING_DASHBOARD.MASS_DEACTIVATION_ALERT_BODY',
    /**
     * @value Profiles disabled
     */
    NB_DISABLED_USERS = 'PROVISIONING_DASHBOARD.NB_DISABLED_USERS',
    /**
     * @value Profiles activated
     */
    NB_ENABLED_USERS = 'PROVISIONING_DASHBOARD.NB_ENABLED_USERS',
    /**
     * @value Filtered out profiles
     */
    NB_FILTERED_OUT_USERS = 'PROVISIONING_DASHBOARD.NB_FILTERED_OUT_USERS',
    /**
     * @value Profiles processed
     */
    NB_PROCESSED_USERS = 'PROVISIONING_DASHBOARD.NB_PROCESSED_USERS',
    /**
     * @value Profiles updated
     */
    NB_UPDATED_USERS = 'PROVISIONING_DASHBOARD.NB_UPDATED_USERS',
    /**
     * @value Daily
     */
    PROCESS_DAILY_PROVISIONING = 'PROVISIONING_DASHBOARD.PROCESS_DAILY_PROVISIONING',
    /**
     * @value Process ID
     */
    PROCESS_ID = 'PROVISIONING_DASHBOARD.PROCESS_ID',
    /**
     * @value On-demand
     */
    PROCESS_ON_DEMAND = 'PROVISIONING_DASHBOARD.PROCESS_ON_DEMAND',
    /**
     * @value Type of synchronization
     */
    PROCESS_USE_CASE = 'PROVISIONING_DASHBOARD.PROCESS_USE_CASE',
    /**
     * @value conflicts detected on misaligned profile information
     */
    PROFILES_ARE_DUPLICATED = 'PROVISIONING_DASHBOARD.DUPLICATED_PROFILE',
    /**
     * @value conflict detected on identical federation value for multiple users
     */
    PROFILES_ARE_MULTIPLE = 'PROVISIONING_DASHBOARD.DUPLICATED_IN_PROVIDER',
    /**
     * @value conflicts detected on inconsistent federation value
     */
    PROFILES_ARE_NOT_ALIGNED = 'PROVISIONING_DASHBOARD.NOT_ALIGNED_PROFILE',
    /**
     * @value profiles will be deactivated.
     * @description "profiles" as identities data.
     */
    PROFILE_WILL_BE_DEACTIVATED = 'PROVISIONING_DASHBOARD.PROFILES_TO_BE_DEACTIVATED',
    /**
     * @value Relation conflicts
     */
    RELATION_CONFLICTS = 'PROVISIONING_DASHBOARD.RELATION_CONFLICTS',
    /**
     * @value Switch to analytics dashboard
     */
    SWITCH_TO_ANALYTICS = 'PROVISIONING_DASHBOARD.SWITCH_TO_ANALYTICS',
    /**
     * @value Switch to legacy dashboard
     */
    SWITCH_TO_LEGACY = 'PROVISIONING_DASHBOARD.SWITCH_TO_LEGACY',
    /**
     * @value Synchronization history
     */
    SYNCHRONIZATION_HISTORY = 'PROVISIONING_DASHBOARD.SYNCHRONIZATION_HISTORY',
    /**
     * @value This feature is still in its early stages of development. The synchronization status may incorrectly appear as aborted.
     */
    SYNCHRONIZATION_HISTORY_BETA_WARNING = 'PROVISIONING_DASHBOARD.SYNCHRONIZATION_HISTORY_BETA_WARNING',
}
